import { Subject } from 'rxjs/Rx';
import { EventEmitter, Injectable, Output } from '@angular/core';

@Injectable()
export class ChatListener {
  public subject = new Subject();
  public chatUnreadFlag = [];
  public unreadMessage: number = 0;
  public offlineChannel: number = 0;
  public chatOpened: any = {
    channel: 'unread',
    data: {},
  };

  @Output() onMessageReceived: EventEmitter<any> = new EventEmitter();
  @Output() onOpenChat: EventEmitter<any> = new EventEmitter();
  @Output() countUnreadChat: EventEmitter<any> = new EventEmitter();

  public updateUnreadMessage = (count: number = 1, ticketIds: any = [], set = false) => {
    if (set) {
      this.chatUnreadFlag = ticketIds;
      this.unreadMessage = count;
    } else {
      if (count > 0) {
        if (!this.chatUnreadFlag.includes(ticketIds[0])) {
          this.unreadMessage += count;
          this.chatUnreadFlag.push(...ticketIds);
          this.chatUnreadFlag = Array.from(new Set(this.chatUnreadFlag));
        }
      } else {
        this.chatUnreadFlag = this.chatUnreadFlag.filter(id => id !== ticketIds[0]);
        this.unreadMessage += count;
      }
    }
    this.countUnreadChat.emit({
      unreadMessage: this.unreadMessage,
      offlineChannel: this.offlineChannel,
    });
  };
  public updateOfflineChannel = (count: number = 1, set = false) => {
    if (set) {
      this.offlineChannel = count;
    } else {
      this.offlineChannel += count;
    }
    this.countUnreadChat.emit({
      unreadMessage: this.unreadMessage,
      offlineChannel: this.offlineChannel,
    });
  };
  public openChat = chat => {
    this.chatOpened = chat;
    this.onOpenChat.emit(chat);
  };
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/chat/chat.listener.ts